module.exports = __webpack_public_path__ + "static/media/top2_on.f5f984df.png";